module.exports = __webpack_public_path__ + "static/img/samajuri (12).df6b6b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (12).jpg
// module id = rB//
// module chunks = 0